export {
  createScenarioMutation,
  deleteScenarioMutation,
  getScenarioOptions,
  getScenarioQueryKey,
  listScenariosOptions,
  listScenariosQueryKey,
  updateScenarioMutation,
} from '@/shared/api/__generated__'
